<template>
  <layout v-if="dataIsLoaded">
    <b-row class="pb-4 pt-2" align-h="between">
      <b-col cols="1">
        <Button location="title" type="white" @click="handleCancel()"
          >Voltar</Button
        >
      </b-col>
      <b-col cols="3" class="text-center">
        <h1 class="title">{{ this.service.id ? 'Editar' : 'Novo' }} Serviço</h1>
      </b-col>
      <b-col cols="1">
        <checkbox-switch
          label="Status"
          v-model="service.active"
          position="top"
          id="active"
        />
      </b-col>
    </b-row>

    <div class="bg-white p-5 mb-3 border-shadow">
      <b-tabs
        v-model="tabIndex"
        active-nav-item-class="font-weight-bold"
        content-class="mt-4"
      >
        <b-tab active :title-link-class="linkClass(0)">
          <template #title> Serviço </template>
          <FormRegister ref="formRegister" />
        </b-tab>
        <b-tab :title-link-class="linkClass(1)">
          <template #title> Fiscal </template>
          <FormTax ref="formTax" />
        </b-tab>
      </b-tabs>
    </div>

    <form-component>
      <footer-form @cancel="handleCancel" @submit="save" />
    </form-component>
  </layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Layout } from '@/components';

import {
  Form as FormComponent,
  FooterForm,
  CheckboxSwitch,
  Button,
} from '@/components/Form';

import { getIdByLastSlash } from '@/reusable/getIdByLastSlash';
import FormRegister from '../components/ServiceResgister/FormRegister';
import FormTax from '../components/ServiceResgister/FormTax';
import FormatMixin from '../../../../Application/mixins/FormatMixin';

export default {
  name: 'InventoryServiceList',
  mixins: [FormatMixin],
  components: {
    Layout,
    FormRegister,
    FormTax,
    FormComponent,
    FooterForm,
    Button,
    CheckboxSwitch,
  },
  data() {
    return {
      arrTabs: ['formRegister'],
      configEmissor: null,
      tabIndex: 0,
      dataIsLoaded: false,
    };
  },
  async mounted() {
    this.configEmissor = await this.getConfigEmissor();
    await this.getData();
  },
  computed: {
    ...mapState('service', ['service']),
  },
  methods: {
    ...mapActions('service', [
      'saveService',
      'updateService',
      'setDetailedService',
    ]),
    ...mapActions('application', ['setLoading', 'getConfigEmissor']),
    linkClass(idx) {
      if (this.$refs[this.arrTabs[idx]]?.$v?.$error) return ['text-danger'];
      if (this.tabIndex === idx) {
        return ['color-default'];
      }
      return ['text-muted'];
    },
    async getData() {
      const id = getIdByLastSlash(this.$route.fullPath);

      if (!id) {
        this.dataIsLoaded = true;
        return;
      }

      try {
        this.setLoading(true);
        await this.setDetailedService(id);

        if (!this.service.id) {
          this.$alert.error('Serviço não encontrado!');
          this.handleCancel();
          return;
        }
        this.dataIsLoaded = true;
      } finally {
        this.setLoading(false);
      }
    },
    isValidService() {
      this.$refs.formRegister.$v.$touch();

      return !this.arrTabs.some((e) => {
        if (this.$refs[e]?.$v?.$error) {
          return true;
        }
        return false;
      });
    },
    async save() {
      if (!this.isValidService()) return;

      try {
        const serviceData = {
          ...this.service,
          price: this.valorUS(this.service.price),
          fiscal: {
            ...this.service.fiscal,
            pisPercentage: this.valorUS(this.service.fiscal.pisPercentage),
            cofinsPercentage: this.valorUS(
              this.service.fiscal.cofinsPercentage,
            ),
          },
        };

        if (serviceData.id) {
          await this.updateService(serviceData);
          this.$alert.success('Serviço salvo com sucesso.');
          this.handleCancel();
          return;
        }

        await this.saveService(serviceData);
        this.$alert.success('Serviço salvo com sucesso.');
        this.handleCancel();
      } finally {
        this.setLoading(false);
      }
    },
    handleCancel() {
      this.$router.push('/cadastre/services');
    },
  },
};
</script>
